import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzCoaching } from './pages'

type TIdToPageMapWoofzCoaching = Record<PageIdWoofzCoaching, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_COACHING: TIdToPageMapWoofzCoaching = {
  [PageIdWoofzCoaching.DOG_SELECTOR]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_coaching/pages/questions/DogSelector').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_coaching/pages/questions/DogSelector'),
  },
  [PageIdWoofzCoaching.PROBLEM_DESCRIPTION]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_coaching/pages/questions/ProblemDescription'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_coaching/pages/questions/ProblemDescription'),
  },
  [PageIdWoofzCoaching.DOG_BREED_COACHING]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_coaching/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_coaching/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  [PageIdWoofzCoaching.DOG_AGE_COACHING]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_coaching/pages/questions/DogAgeQuestion'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_coaching/pages/questions/DogAgeQuestion'),
  },
  [PageIdWoofzCoaching.DOG_PROFILE_COACHING]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_coaching/pages/questions/dog-profile/DogProfile'
      ).then((m) => ({
        default: m.DogProfile,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_coaching/pages/questions/dog-profile/DogProfile'
      ),
  },
  [PageIdWoofzCoaching.SUBSCRIPTIONS_COACHING]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_coaching/pages/subscriptions/Subscriptions'
      ).then((m) => ({
        default: m.TrialPriceSubscriptionsPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_coaching/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzCoaching.CANCEL_OFFER_COACHING]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_coaching/pages/subscriptions/CancelOffer'
      ).then((m) => ({
        default: m.CancelOffer,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_coaching/pages/subscriptions/CancelOffer'),
  },
  [PageIdWoofzCoaching.CALENDLY_COACHING]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_coaching/pages/final/CalendlyWidgetPageVariant3'
      ).then((m) => ({
        default: m.CalendlyWidgetPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_coaching/pages/final/CalendlyWidgetPageVariant3'
      ),
  },
  [PageIdWoofzCoaching.ALL_SET_COACHING]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_coaching/pages/final/AllSetVC').then((m) => ({
        default: m.AllSetVCPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_coaching/pages/final/AllSetVC'),
  },
  [PageIdWoofzCoaching.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
